export const ImagesAssets = {
    logoIcon: require('./logo_small.png'),
    logoBig: require('./logo_big.png')
    // clientsIcon: require('./clients.svg'),
    // dashboardIcon: require('./dashboard.png'),
    ///you can add more many images like this here.
};